// The scroll cue's arithmetic (BRK-S240 page, BRK-S241 sidebar list). The
// component only reads rects and scroll metrics and hands them in; every
// decision is made here, so it is unit-tested without layout (jsdom has none).
//
// Both cues ask the same question in one coordinate space: how far does the
// content's end sit below the visible bottom? On the page that is the gap
// between two viewport rects (the content's end and the sticky cue line); in a
// scroll box it is `scrollHeight - scrollTop` against `clientHeight`.

/** Less than this hidden is trailing whitespace or sub-pixel rounding, not
 *  "more below", so the cue stays hidden. */
export const SCROLL_CUE_THRESHOLD_PX = 24;

/** A scroll box such as the sidebar's list ends in no padding, so anything
 *  past rounding is a cut-off row: the cue shows much sooner. */
export const LIST_CUE_THRESHOLD_PX = 4;

/** One click scrolls this share of the visible band; the rest stays on screen
 *  as context, so the reader doesn't lose their place. */
export const SCROLL_CUE_STEP = 0.8;

/** How far the content's end runs past the visible bottom, in px (never
 *  negative). */
export function hiddenBelow(contentEnd: number, visibleBottom: number): number {
  return Math.max(0, contentEnd - visibleBottom);
}

/** Whether enough is hidden below to show the cue. */
export function hasMoreBelow(
  hiddenPx: number,
  threshold = SCROLL_CUE_THRESHOLD_PX,
): boolean {
  return hiddenPx > threshold;
}

/** How far one click scrolls: 80% of the visible band, and always at least a
 *  pixel, so a click is never a no-op. */
export function scrollStep(visibleTop: number, visibleBottom: number): number {
  return Math.max(
    1,
    Math.round((visibleBottom - visibleTop) * SCROLL_CUE_STEP),
  );
}
